export default "__VITE_ASSET__D$ekI8pt__"